<template>
  <canvas
    ref="minimap"
    class="minimap"
    :width="width"
    :height="height"
  />
</template>

<script>
export default {
  name: 'CanvasMiniMap',
  props: {
  },
  data() {
    return {
      bus: this.$root.bus,
      ratio: null,
      width: 0,
      height: 0,
      images: { front: new Image(), back: new Image() },
      side: 'front',
    };
  },
  methods: {
    updateMap(viewport) {
      const ctx = this.$refs.minimap.getContext('2d');
      ctx.clearRect(0, 0, this.width, this.height);

      const invert = this.side === 'back' ? -1 : 1;
      ctx.drawImage(this.images[this.side], 0, 0, this.width, this.height);

      if (!viewport) return;

      viewport = viewport?.map((pt) => ({
        x: (pt.x * invert) * this.ratio + this.width / 2,
        y: -pt.y * this.ratio + this.height / 2,
      }));
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.lineTo(0, this.height);
      ctx.lineTo(this.width, this.height);
      ctx.lineTo(this.width, 0);
      ctx.moveTo(viewport[0].x, viewport[0].y);
      ctx.lineTo(viewport[3].x, viewport[3].y);
      ctx.lineTo(viewport[2].x, viewport[2].y);
      ctx.lineTo(viewport[1].x, viewport[1].y);
      ctx.fillStyle = 'rgba(255, 255, 255, 0.75)';
      ctx.fill();
    },
  },
  mounted() {
    this.bus.on('publishViewport', ({ viewport, boundingBox }) => {
      const scale = 4;

      this.width = viewport.width / scale;
      this.height = viewport.height / scale;
      this.ratio = Math.min(
        this.width / ((boundingBox.max.x - boundingBox.min.x)),
        this.height / ((boundingBox.max.y - boundingBox.min.y)),
      ) / 1.1; // Apply same scale factor here as used in WebGlViewer
    });
    this.bus.on('publishFocusViewport', (viewport) => {
      this.updateMap(viewport);
    });
    this.bus.on('publishRendering', ({ data, side }) => {
      const image = new Image();
      image.src = data;
      // Trigger update of map once image has been loaded into memory.
      image.onload = () => this.updateMap();
      this.images[side] = image;
    });
    this.bus.on('sideChanged', (side) => {
      this.side = side;
    });
  },
};
</script>

<style scoped lang="scss">
.minimap {
  position: absolute;
  bottom: 0px;
  right: 0px;
  margin-bottom: 1.5rem;
  margin-right: 1.5rem;
  border: 1px solid #FF6711;
  border-radius: 12px 12px 12px 12px;
}
</style>
